import { render } from "./users_roles.html?vue&type=template&id=ad24b0ea&external"
import script from "./users_roles.js?vue&type=script&lang=js&external"
export * from "./users_roles.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__